import styled, { css } from 'styled-components';

import { TextColorsType } from '@r1-frontend/ui-kit/themes/colors/types';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';
import { FontWeight, getFontWeightByName } from '@r1-frontend/ui-kit/themes/typography.fontWeight';
import { TextSizeType } from '@r1-frontend/ui-kit/themes/typography.paragraphs';

/**
 * Getting text elements from the "The periodic table of HTML elements by Josh Duck"
 * {@link https://atomicdesign.bradfrost.com/chapter-2/#the-atomic-design-methodology}
 */
export const textLevelElements = [
    'span', 'a', 'rt', 'rp', 'dfn', 'abbr', 'q', 'city', 'em', 'time', 'var', 'samp', 'i', 'b', 'sub',
    'sup', 'small', 'strong', 'mark', 'ruby', 'ins', 'del', 'bdi', 'bdo', 's', 'kbd', 'wbr', 'code',
] as const;

export type TextLevelElements = typeof textLevelElements[number];

export type TextProperties = {
    /**
     * Размер текста
     * @default sm
     */
    $size?: TextSizeType,

    /**
     * Средняя ширина текста
     */
    $weight?: FontWeight, // if you need more variations, and you have more than three variation of font, you can use the FontWeight type from the `typography.fontWeight`

    /**
     * Цвет текста
     */
    $color?: TextColorsType,

    /**
     * Семантический элемент для отрисовки
     * @default span
     */
    as?: TextLevelElements,
}

const Text = styled.span<TextProperties>`
    ${({ theme, $size = 'sm', $weight, $color }: ThemedProperties<TextProperties>) => css`
        font-size: ${theme.typography.text[$size].fs}px;
        line-height: ${theme.typography.text[$size].lh}px;
        color: ${$color ? theme.colors.text[$color] : theme.colors.text.primary};
        
        ${$weight ? `font-weight: ${getFontWeightByName($weight)}` : ''};
    `};
`;

Text.displayName = 'Text';

export { Text };
